import { render } from "./CurrentPlanBadge.vue?vue&type=template&id=6eb2258f"
import script from "./CurrentPlanBadge.vue?vue&type=script&lang=js"
export * from "./CurrentPlanBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__